import React from 'react';
import Header from './HeaderComponent';
import About from './AboutComponent';
import Education from './EducationDetails.js';
import Certificates from './CertificateComponent';
import Projects from './ProjectComponents';
import Footer from './FooterComponent';

function Home() {
    return(
        <div>
            <Header />
            <About />
            <Education />
            <Certificates />
            <Projects />
            <Footer />
        </div>
    );
}

export default Home;